"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GasConnection_1 = tslib_1.__importDefault(require("./GasConnection"));
const ElectricityConnection_1 = tslib_1.__importDefault(require("./ElectricityConnection"));
class AddressWithConnections extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, base_models_1.IsAddressKey)(),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: '1234AB_56_C',
        description: `Address of the building for which the offer is intended.`,
    }),
    tslib_1.__metadata("design:type", String)
], AddressWithConnections.prototype, "addressKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    (0, base_models_1.Docs)({
        example: false,
        description: `Also known as complex bepaling.
      This information is maintained by EDSN.
      For tariffs, if residential is true and complex is false, that address will get belasting voordeel.
      If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
      Defaults to false.`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], AddressWithConnections.prototype, "complex", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Boolean),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: false,
        description: `If true it means that is a "regular" home.
    It only influence if it receives tax benefit.
    If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
    Defaults to true`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], AddressWithConnections.prototype, "residential", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GasConnection_1.default),
    tslib_1.__metadata("design:type", Array)
], AddressWithConnections.prototype, "gasConnections", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ElectricityConnection_1.default),
    tslib_1.__metadata("design:type", Array)
], AddressWithConnections.prototype, "electricityConnections", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears), { each: true }),
    (0, base_models_1.Docs)({
        example: [base_models_1.DurationInYears.FLEX, base_models_1.DurationInYears.ONE],
        description: `Filter for which contract duration you want the offers for this address specifically. This will override the Durations in the root level of the request.
If it is left empty, it will fetch Offers with all the possible durations.`,
    }),
    tslib_1.__metadata("design:type", Array)
], AddressWithConnections.prototype, "durations", void 0);
exports.default = AddressWithConnections;
